import React, {createContext, useContext} from 'react';

import {Run} from '../../util/runTypes';

type RunWorkspaceRunProviderProps = {
  children: React.ReactNode;
  run: Run | null;
};

const RunWorkspaceRunContext = createContext<Run | null>(null);

export const RunWorkspaceRunProvider = ({
  children,
  run,
}: RunWorkspaceRunProviderProps) => {
  return (
    <RunWorkspaceRunContext.Provider value={run}>
      {children}
    </RunWorkspaceRunContext.Provider>
  );
};

export const useRunWorkspaceRunContext = () => {
  const value = useContext(RunWorkspaceRunContext);
  if (value == null) {
    throw new Error(
      'useRunWorkspaceRunContext must be used within a RunWorkspaceRunContext'
    );
  }
  return value;
};

export const useRunWorkspaceRunContextMaybe = () => {
  return useContext(RunWorkspaceRunContext);
};

export const useIsSingleRun = () => {
  return useRunWorkspaceRunContextMaybe() != null;
};
